import { PlatformEnums } from "./enums";
import efxProLogo from "_assets/images/logos/efx-pro-logo.png";
import mt5Logo from "_assets/images/logos/mt5-logo.png";
import efxLiteLogo from "_assets/images/logos/efx-lite-logo.png";

export const AccountCurrenciesCountryCodeMap = {
  USD: "us",
  KES: "ke",
};

export const AccountChangeType = {
  Password: "Password",
  Leverage: "Leverage",
};

export const AccountIdParamValue = "{accountId}";
export const LoginSidParamValue = "{loginSid}";


export const AccountPlatformAccountTypeIdMap = {
  [PlatformEnums.EFXLite]: [11, 15],
  [PlatformEnums.MT5]: [2, 3, 4, 5, 6, 7],
  [PlatformEnums.EFXPro]: [10, 12],
};

export const accountPlatformsItems = [
  {
    title: "MT5",
    value: PlatformEnums.MT5,
    subtitle: "Access powerful charting and automated trading.",
    tagLine: "The classic standard re-imagined.",
    logo: mt5Logo,
  },
  {
    title: "EFX Lite",
    value: PlatformEnums.EFXLite,
    subtitle: "Trade anytime, anywhere with M-Pesa deposits.",
    tagLine: "Your empire in your pocket.",
    logo: efxLiteLogo,
  },
  {
    title: "EFX Pro",
    value: PlatformEnums.EFXPro,
    subtitle: "Advanced trading with professional tools.",
    tagLine: "Full power. No limits.",
    logo: efxProLogo,
  },
];
